import ev from "../util/enumValue";

enum Font {
    PRIMARY = ev('PRIMARY', 1),
    SECONDARY = ev('SECONDARY', 2),
    ALEGREYA = ev('ALEGREYA', 3),
    ALEGREYA_SANS = ev('ALEGREYA_SANS', 4),
    ALICE = ev('ALICE', 5),
    AMATIC_SC = ev('AMATIC_SC', 6),
    AMIKO = ev('AMIKO', 7),
    AMIRI = ev('AMIRI', 8),
    ANNIE_USE_YOUR_TELESCOPE = ev('ANNIE_USE_YOUR_TELESCOPE', 9),
    ARCHITECTS_DAUGHTER = ev('ARCHITECTS_DAUGHTER', 10),
    ARCHIVO_NARROW = ev('ARCHIVO_NARROW', 11),
    AZERET_MONO = ev('AZERET_MONO', 12),
    BAD_SCRIPT = ev('BAD_SCRIPT', 13),
    BALOO_2 = ev('BALOO_2', 14),
    BIORHYME = ev('BIORHYME', 15),
    BODONI_MODA = ev('BODONI_MODA', 16),
    BUNGEE_INLINE = ev('BUNGEE_INLINE', 17),
    CARDO = ev('CARDO', 18),
    CARTER_ONE = ev('CARTER_ONE', 19),
    CAVEAT = ev('CAVEAT', 20),
    CAVEAT_BRUSH = ev('CAVEAT_BRUSH', 21),
    CEDARVILLE_CURSIVE = ev('CEDARVILLE_CURSIVE', 22),
    CEVICHE_ONE = ev('CEVICHE_ONE', 23),
    CHIVO = ev('CHIVO', 24),
    COMING_SOON = ev('COMING_SOON', 25),
    CORBEN = ev('CORBEN', 26),
    CORMORANT = ev('CORMORANT', 27),
    COURGETTE = ev('COURGETTE', 28),
    DEKKO = ev('DEKKO', 29),
    DM_SANS = ev('DM_SANS', 30),
    EB_GARAMOND = ev('EB_GARAMOND', 31),
    ECZAR = ev('ECZAR', 32),
    ERICA_ONE = ev('ERICA_ONE', 33),
    EXPLETUS_SANS = ev('EXPLETUS_SANS', 34),
    FIRA_SANS = ev('FIRA_SANS', 35),
    FREDOKA_ONE = ev('FREDOKA_ONE', 36),
    FRUKTUR = ev('FRUKTUR', 37),
    GIVE_YOU_GLORY = ev('GIVE_YOU_GLORY', 38),
    GOCHI_HAND = ev('GOCHI_HAND', 39),
    HANDLEE = ev('HANDLEE', 40),
    HOMEMADE_APPLE = ev('HOMEMADE_APPLE', 41),
    IBM_PLEX_SANS = ev('IBM_PLEX_SANS', 42),
    ICEBERG = ev('ICEBERG', 43),
    INCONSOLATA = ev('INCONSOLATA', 44),
    INDIE_FLOWER = ev('INDIE_FLOWER', 45),
    INKNUT_ANTIQUA = ev('INKNUT_ANTIQUA', 46),
    INTER = ev('INTER', 47),
    JUST_ANOTHER_HAND = ev('JUST_ANOTHER_HAND', 48),
    JUST_ME_AGAIN_DOWN_HERE = ev('JUST_ME_AGAIN_DOWN_HERE', 49),
    KALAM = ev('KALAM', 50),
    KARLA = ev('KARLA', 51),
    KAUSHAN_SCRIPT = ev('KAUSHAN_SCRIPT', 52),
    KAVOON = ev('KAVOON', 53),
    KENIA = ev('KENIA', 54),
    KRISTI = ev('KRISTI', 55),
    LA_BELLE_AURORE = ev('LA_BELLE_AURORE', 56),
    LATO = ev('LATO', 57),
    LIBRE_BASKERVILLE = ev('LIBRE_BASKERVILLE', 58),
    LIBRE_FRANKLIN = ev('LIBRE_FRANKLIN', 59),
    LILITA_ONE = ev('LILITA_ONE', 60),
    LORA = ev('LORA', 61),
    LUSTRIA = ev('LUSTRIA', 62),
    MANROPE = ev('MANROPE', 63),
    MARCK_SCRIPT = ev('MARCK_SCRIPT', 64),
    MERIENDA = ev('MERIENDA', 65),
    MERRIWEATHER = ev('MERRIWEATHER', 66),
    MONOTON = ev('MONOTON', 67),
    MONTSERRAT = ev('MONTSERRAT', 68),
    MUKTA = ev('MUKTA', 69),
    MULISH = ev('MULISH', 70),
    NEUCHA = ev('NEUCHA', 71),
    NEUTON = ev('NEUTON', 72),
    NOTHING_YOU_COULD_DO = ev('NOTHING_YOU_COULD_DO', 73),
    NOTO_SANS = ev('NOTO_SANS', 74),
    NUNITO = ev('NUNITO', 75),
    NUNITO_SANS = ev('NUNITO_SANS', 76),
    OI = ev('OI', 77),
    OPEN_SANS = ev('OPEN_SANS', 78),
    OSWALD = ev('OSWALD', 79),
    OXYGEN = ev('OXYGEN', 80),
    PANGOLIN = ev('PANGOLIN', 81),
    PATRICK_HAND = ev('PATRICK_HAND', 82),
    PATRICK_HAND_SC = ev('PATRICK_HAND_SC', 83),
    PERMANENT_MARKER = ev('PERMANENT_MARKER', 84),
    PIAZZOLLA = ev('PIAZZOLLA', 85),
    PLAYFAIR_DISPLAY = ev('PLAYFAIR_DISPLAY', 86),
    POPPINS = ev('POPPINS', 87),
    PROZA_LIBRE = ev('PROZA_LIBRE', 88),
    PT_SANS = ev('PT_SANS', 89),
    PT_SERIF = ev('PT_SERIF', 90),
    QUICKSAND = ev('QUICKSAND', 91),
    RAKKAS = ev('RAKKAS', 92),
    RALEWAY = ev('RALEWAY', 93),
    RALEWAY_DOTS = ev('RALEWAY_DOTS', 94),
    RAMMETTO_ONE = ev('RAMMETTO_ONE', 95),
    REENIE_BEANIE = ev('REENIE_BEANIE', 96),
    ROBOTO = ev('ROBOTO', 97),
    ROBOTO_CONDENSED = ev('ROBOTO_CONDENSED', 98),
    ROBOTO_SLAB = ev('ROBOTO_SLAB', 99),
    ROCK_SALT = ev('ROCK_SALT', 100),
    RUBIK = ev('RUBIK', 101),
    SEAWEED_SCRIPT = ev('SEAWEED_SCRIPT', 102),
    SHADOWS_INTO_LIGHT = ev('SHADOWS_INTO_LIGHT', 103),
    SHADOWS_INTO_LIGHT_TWO = ev('SHADOWS_INTO_LIGHT_TWO', 104),
    SHRIKHAND = ev('SHRIKHAND', 105),
    SOURCE_SANS_PRO = ev('SOURCE_SANS_PRO', 106),
    SOURCE_SERIF_PRO = ev('SOURCE_SERIF_PRO', 107),
    SPACE_GROTESK = ev('SPACE_GROTESK', 108),
    SPACE_MONO = ev('SPACE_MONO', 109),
    SPECTRAL = ev('SPECTRAL', 110),
    SWANKY_AND_MOO_MOO = ev('SWANKY_AND_MOO_MOO', 111),
    SYNE = ev('SYNE', 112),
    UBUNTU = ev('UBUNTU', 113),
    ULTRA = ev('ULTRA', 114),
    VOLLKORN = ev('VOLLKORN', 115),
    WALTER_TURNCOAT = ev('WALTER_TURNCOAT', 116),
    WIRE_ONE = ev('WIRE_ONE', 117),
    WORK_SANS = ev('WORK_SANS', 118),
    YATRA_ONE = ev('YATRA_ONE', 119),
    BERNIER_DISTRESSED = ev('BERNIER_DISTRESSED', 120),
    BUILT_TITLING = ev('BUILT_TITLING', 121),
    AGRANDIR = ev('AGRANDIR', 122),
    DK_LEMON_YELLOW_SUN = ev('DK_LEMON_YELLOW_SUN', 123),
    SUSHITO = ev('SUSHITO', 124),
    CUSTOM_FONT = ev('CUSTOM_FONT', 125)
}

export default Font;
